/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius, colors, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Content = styled.div({
  margin: `${gridSize()}px 0`,
});

export const CloneDialogHeader = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  padding: `${gridSize() * 2}px`,
});

export const ButtonGroup = styled.div({
  marginTop: `${gridSize() * 3}px`,
});

export const InlineContent = styled.div({
  minWidth: '400px',
});

export const CloneClient = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flex: 1,
  border: `1px solid ${token('color.border', colors.N30)}`,
  borderRadius: `${borderRadius()}px`,
  padding: `${gridSize() * 2}px`,
  marginRight: `${gridSize()}px`,
  '&:last-child': {
    marginRight: 0,
  },
});

export const CloneClients = styled.div({
  display: 'flex',
  marginTop: `${gridSize() * 3}px`,
});
